<template>
    <div data-uk-rr-grid-item>
        <div class="store-locator__card uk-card uk-card-default uk-card-body uk-card-small uk-card-hover">
            <div class="store-locator__card-inner uk-flex uk-flex-between uk-flex-wrap">
                <div v-if="item.featured_media">
                    <figure class="store-locator__figure uk-margin-remove uk-position-relative">
                        <div v-html="item.featured_media.thumbnail"></div>
                        <a v-if="item.url" :href="item.url" class="uk-position-cover uk-visible-small"></a>
                        <a v-if="item.url" :href="item.url" class="uk-position-cover uk-hidden@m"></a>
                    </figure>
                </div>
                <div class="store-locator__description uk-flex-1 uk-margin-small-left uk-text-small">
                    <p class="uk-margin-remove">
                        <strong>{{item.name}}</strong><br/>
                        {{item.street}}<br/>
                        {{item.postcode}} {{item.city}} <span v-if="item.region">({{item.region.abbreviation}})</span>
                        <span v-if="item.country">{{item.country.code}}</span>
                    </p>
                    <div>
                        <div v-if="item.opening_hours">
                            <i class="fal fa-clock"></i> {{ $t('rubinred.store-locator.common.opening_hours_today') }}: {{item.opening_hours.today}}
                        </div>
                        <div v-if="item.position.distance" class="uk-hidden@l">
                            <i class="fal fa-map-marker-alt"></i> <strong>{{human_distance(item.position.distance)}} Km</strong> {{ $t('rubinred.store-locator.common.from_you') }}
                        </div>
                    </div>
                </div>
                <div v-if="item.position.distance" class="store-locator__info uk-visible@l uk-margin-small-left uk-text-small">
                    <i class="fal fa-map-marker-alt"></i> <strong>{{human_distance(item.position.distance)}} Km</strong> {{ $t('rubinred.store-locator.common.from_you') }}
                </div>
            </div>
            <div class="uk-margin-small uk-hidden@m">
                <div class="store-locator__button-group uk-button-group uk-width-1-1">
                    <a v-show="item.phone_number" :href="item.phone_number" class="uk-button uk-button-secondary uk-button-small uk-flex-1">
                        {{ $t('rubinred.store-locator.actions.retailer_call') }}
                    </a>
                    <li v-show="item.url">
                        <a :href="item.url" class="uk-button uk-button-primary uk-button-small uk-flex-1">
                            {{ $t('rubinred.store-locator.actions.retailer_detail') }}
                        </a>
                    </li>
                </div>
            </div>

            <a v-show="item.url" :href="item.url" class="uk-position-cover uk-visible@m"></a>
        </div>
    </div>
</template>

<script>
    export default {
      props: {
        item : {
          type: Object,
          required: true,
        },
      },
      computed: {
        humanDistance() {
          return Intl.NumberFormat(App.locales.current, {maximumFractionDigits: 2}).format(this.item.position.distance / 1000);
        },
      }
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/store-locator/assets/js/components/StoreLocatorItem.vue